import { createStyles, Theme } from '@material-ui/core';

export const commentsDialogStyles = (theme: Theme) => createStyles({
    closeButton: {
        position: 'absolute',
        right: theme.spacing.unit,
        top: theme.spacing.unit,
    },
});